import { Navigate, Route, Routes } from "react-router-dom";
import PimacoSite from "./site";
import APWeb from "./APWeb";
import PoliticaPrivacidade from "./site/institucional/politica_privacidade";
import PoliticaQualidade from "./site/institucional/politica_qualidade";
import QuemSomos from "./site/institucional/quemsomos";
import Faq from "./site/faq";
import LeituraEtiquetasPimaco from "./site/leitura_etiquetas";
import Gabaritos from "./site/downloads/gabaritos";
import Parametros from "./site/downloads/parametros";
import Health from "./health";

export default function PimacoRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PimacoSite />}>
        <Route index element={<Navigate to="/APWeb" />} />
        <Route path="/politica_privacidade" element={<PoliticaPrivacidade />} />
        <Route path="/politica_qualidade" element={<PoliticaQualidade />} />
        <Route path="/quemsomos" element={<QuemSomos />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/leitura_etiquetas" element={<LeituraEtiquetasPimaco />} />
        <Route path="/downloads/gabaritos" element={<Gabaritos />} />
        <Route path="/downloads/parametros" element={<Parametros />} />
      </Route>

      <Route path="/APWeb" element={<APWeb />} />

      <Route path="/health" element={<Health />} />
    </Routes>
  );
}
